import { useState } from "react";

const useCustomTooltip = () => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return { open, handleTooltipClose, handleTooltipOpen };
};

export default useCustomTooltip;
